/** Discriminates a portfolio list/detail item between a contract and a property. */
export enum PortfolioItemKind {
	Portfolio = "portfolio",
	Property = "property",
}
